// en, de, fr, pt
export default {
  en: {
    regularize: 'Regularize now',
    Dashboard: "Dashboard",
    eCommerce: "eCommerce",
    Apps: "Apps",
    Todo: "Todo",
    Chat: "Chat",
    Email: "Email",
    Calendar: "Calendar",
    FullCalendar: "Full Calendar",
    SimpleCalendar: "Simple Calendar",
    Shop: "Shop",
    Cart: "Cart",
    WishList: "Wish List",
    Checkout: "Checkout",
    UIElements: "UI Elements",
    DataList: "Data List",
    ListView: "List View",
    ThumbView: "Thumb View",
    Grid: "Grid",
    Vuesax: "Vuesax",
    Tailwind: "Tailwind",
    Colors: "Colors",
    Card: "Card",
    CreditCard: "Cartão de Crédito",
    UnlockInstantly: "Liberação Imediata",
    Basic: "Basic",
    Statistics: "Statistics",
    Analytics: "Analytics",
    CardActions: "Card Actions",
    CardColors: "Card Colors",
    Table: "Table",
    agGridTable: "agGrid Table",
    Components: "Components",
    Alert: "Alert",
    Avatar: "Avatar",
    Badge: "Badge",
    Breadcrumb: "Breadcrumb",
    Button: "Button",
    ButtonGroup: "Button Group",
    Chip: "Chip",
    Collapse: "Collapse",
    Dialogs: "Dialogs",
    Divider: "Divider",
    DropDown: "DropDown",
    List: "List",
    Loading: "Loading",
    Navbar: "Navbar",
    Notifications: "Notifications",
    Pagination: "Pagination",
    Popup: "Popup",
    Progress: "Progress",
    Sidebar: "Sidebar",
    Slider: "Slider",
    Tabs: "Tabs",
    Tooltip: "Tooltip",
    Upload: "Upload",
    FormsAndTable: "Forms & Table",
    FormElements: "Form Elements",
    Select: "Select",
    Switch: "Switch",
    Checkbox: "Checkbox",
    Radio: "Radio",
    Input: "Input",
    NumberInput: "Number Input",
    Textarea: "Textarea",
    FormLayouts: "Form Layouts",
    FormWizard: "Form Wizard",
    FormValidation: "Form Validation",
    FormInputGroup: "Form Input Group",
    Pages: "Pages",
    Authentication: "Authentication",
    Login: "Login",
    Register: "Register",
    ForgotPassword: "Forgot Password",
    ResetPassword: "Reset Password",
    LockScreen: "Lock Screen",
    Miscellaneous: "Miscellaneous",
    ComingSoon: "Coming Soon",
    Error: "Error",
    404: "404",
    500: "500",
    NotAuthorized: "Not Authorized",
    Maintenance: "Maintenance",
    Profile: "Profile",
    Invoice: "Invoice",
    FAQ: "FAQ",
    Search: "Search",
    KnowledgeBase: "Knowledge Base",
    ChartsAndMaps: "Charts & Maps",
    Charts: "Charts",
    ApexCharts: "Apex Charts",
    chartjs: "chartjs",
    echarts: "echarts",
    chartist: "chartist",
    GoogleMap: "Google Map",
    Extensions: "Extensions",
    QuillEditor: "Quill Editor",
    DragAndDrop: "Drag & Drop",
    Datepicker: "Datepicker",
    DatetimePicker: "Datetime Picker",
    AccessControl: "Access Control",
    EditorView: "Editor View",
    AdminView: "Admin View",
    I18n: "I18n",
    Carousel: "Carousel",
    Clipboard: "Clipboard",
    ContextMenu: "Context Menu",
    StarRatings: "Star Ratings",
    Autocomplete: "Autocomplete",
    Tree: "Tree",
    Others: "Others",
    MenuLevels: "Menu Levels",
    MenuLevel2p1: "Menu Level 2.1",
    MenuLevel2p2: "Menu Level 2.2",
    MenuLevel3p1: "Menu Level 3.1",
    MenuLevel3p2: "Menu Level 3.2",
    DisabledMenu: "Disabled Menu",
    Support: "Support",
    videos: 'Videos',
    Documentation: "Documentation",
    RaiseSupport: "Raise Support",
    demoTitle: "Card Title",
    VIPService: "VIP Service:",
    AddDevice: "Add Device",
    OneTimeFee: 'One Time Fee',
    PlanWillBeAppliedTo: 'The plan will be applied to the following device',
    GoBack: 'Go Back',
    demoText:
      "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
    TextMessageAddDevice: "Your account doesn't have any devices registered, add one right now to start monitoring",
    Warning: "WARNING",
    ReleaseLicense: "You have a license released on your account, to unlock all mobile content",
    TextUnlock: "just click unlock",
    UnlockContent: "Unlock Content",
    ContinuToTest: "Continue to Test",
    Continue: "Continue",
    DeleteDevice: "Delete Device",
    AllPlans: "All Plans",
    LastUpdate: "Last update:",
    Android: "Android",
    VersionWspy: "App Version",
    LicenseValidity: "License Validity",
    TestValidity: "Test Validity",
    ViewData: "View Data",
    ChoosePlan: "Choose Plan",
    TrialExpired: "Your trial has expired. Please purchase a package.",
    IncreaseValidity: "Increase Validity",
    Computer: "Computer",
    License: "License",
    ShelfLife: "Shelf Life",
    Available: "Available",
    OneMonth: "1 Month",
    Months: "Months",
    Days: "Days",
    Day: "Day",
    DownloadNow: "Download now",
    TxtDelete: "By clicking on each button the data will be deleted",
    TxtDeleteTwo: "no confirmation",
    TxtDeleteThree: "A task will be scheduled to delete the data which may take up to 24 hours to complete.",
    TxtDownload: "Select the data you want to download and click confirm.",
    TxtDownloadTwo: "without confirmation",
    TxtDownloadThree: "A task will be scheduled to prepare the file which may take up to 24 hours to complete. You will receive an email when it is ready.",
    Return: "Return",
    Chats: "Chats",
    Audios: "Audios",
    Location: "Location",
    SafeZone: "Safe Zone",
    Instagram: "Instagram",
    Keys: "Keys",
    Websites: "Websites",
    SMS: "SMS",
    Contacts: "Contacts",
    WebSearch: "Web Search",
    PhotoRemote: "Photo Remote",
    Microphone: "Microphone",
    PhotoGallery: "Gallery",
    Screenshot: "Screenshot",
    Battery: "Battery",
    Connection: "Connection",
    UpdateApp: "Update App",
    UpdatedVersion: "Updated Version",
    DataOf: "Data of",
    Active: "Active",
    Inactive: "Inactive",
    WifiNetwork: "Wifi Network",
    WifiName: "WIFI Network Name",
    Number: "Number",
    ValidUntil:"Valid until:",
    Provider: "Provider",
    TxtPayment: "Payment by credit card",
    Extend: "Extend",
    Purchase: "Purchase",
    TxtUnlockOne: "Read All Text Below Carefully",
    TxtUnlockTwo: "Choose the license you want to apply to the device",
    TxtUnlockThree: "and click Confirm.",
    TxtUnlockFour: "If the device has no license, the content will be unlocked until the license expires.",
    TxtUnlockFive: "If the device is already unlocked, the purchased months will be added to the device's current period.",
    TxtUnlockSix: "ATTENTION: This action is irreversible. Once confirmed which license to use, it will not be possible to activate the same license on another device.",
    TxtUnlockSeven: "List of Available Licenses",
    AcquiredIn: "Acquired in",
    ConfirmTerms: "I confirm that I have read the terms.",
    Cancel: "Cancel",
    MonitorAndroid: "Monitor Android Phone",
    MonitorAndroidTwo: "If you are viewing this page from the device you want to monitor, just press",
    MonitorAndroidThree: "or, if you are going to monitor a different device, note the short link",
    ContactUs: "Contact us",
    Guide: "Guide",
    ClickHere: "Click here",
    MonitorComputer: "Monitor Windows Computer",
    RegisterLicense: "or, if you have already installed it on your computer, just register the license",
    RegisterLicenseComputer: "Register License",
    ComputerNickname: "Computer Nickname",
    ReleaseContent: "Release Content",
    TxtReleaseContentOne: "Buy one of the plans below and have access to all monitored content completely without restrictions.",
    TxtReleaseContentTwo: "Your content has been blocked because your account is under test. Buy one of our plans and everything is free",
    JustinTime: "JUST IN TIME",
    TxtPaymentTwo: "if paying via Credit Card or PayPal.",
    Discount: "Discount:",
    RecurringSubscription: "Recurring Subscription:",
    In: "in",
    Per: "per",
    Initial: "Initial",
    Monthly: "Monthly",
    BuyNow: "Buy now",
    SubscribeNow: "Subscribe Now",
    Telephone: "Telephone",
    whatsappChat: "WhatsApp Chat",
    whatsappAudio: "WhatsApp Audio",
    badoo: "Badoo",
    kwai: "Kwai",
    snapchat: "Snapchat",
    telegram: "Telegram",
    tinder: "Tinder",
    apps: "Apps",
    keys: "Typed Keys",
    support: "Support",
    Terms: "Terms",
    Today: "Today",
    Yesterday: "Yesterday",
    LastSevenDays: "Last 7 Days",
    LastThirtyDays: "Last 30 Days",
    LastNinetyDays: "Last 90 Days",
    AllRecords: "All Records",
    NAME: "NAME",
    ID: "ID",
    DateTimeInstallation: "DATE/TIME INSTALLATION",
    ImportantWarning: "Important Warning",
    Lock: "The rest of the content has been blocked because your account is on",
    FreeVersion: "Free Version",
    FreeVersionTwo: "unlock content right now.",
    ReleaseFullContent: "Release Full Content",
    DateTime: "DATE/TIME",
    NumberN: "NUMBER",
    DURATION: "DURATION",
    TYPE: "TYPE",
    Received: "Received",
    Effect: "Effect",
    Lost: "Lost",
    Refused: "Refused",
    TELEPHONE: "TELEPHONE",
    EMAIL: "EMAIL",
    NoData: "No contact found with that name or number",
    TxtVip: "This function is only available for devices with a VIP plan.",
    whatsappCall: "WhatsApp Calls",
    TxtClientVip: "This function is only available for VIP customers",
    SeePlans: "See Plans",
    DATE: "DATE",
    RESEARCHTERM: "RESEARCH TERM",
    LINK: "LINK",
    SearchbyTerm: "Search by Term",
    Front: "Front",
    Rear: "Rear",
    TxtFrontalCamera: "* Photos taken are not stored on the monitored device.",
    TxtFrontalCamera2: "* The photo function is unlimited, but use it in moderation, as Android may block the",
    TxtFrontalCamera3: "remote control for overuse.",
    TxtFrontalCamera4: "No items found in the selected period",
    TxtKeys: "TYPED TEXT",
    APPLICATION: "APPLICATION",
    WEBSITEACCESSED: "WEBSITE ACCESSED",
    DELETE_NOTICE_PART_1: "This device will be deleted in",
    DELETE_NOTICE_PART_2: "days. Choose a plan to prevent this device from being deleted.",
    demoDashboardAlert:
      'This screen is the real mobile dashboard with fictional data (no API calls).',
    demoNotifyTitle: 'Demonstration',
    demoNotifyText: 'Switching panel versions is disabled in demo mode.',
    demoExplorerBannerTitle: 'Demonstration',
    demoExplorerBannerLead:
      'Same layout as the panel; fictional content.',
    demoExplorerCreateAccount: 'Create account',
    demoExplorerSearchPlaceholder: 'Search (demo)',
    demoExplorerDemoPrefix: 'Demo',
    demoExplorerSocialProofTitle:
      'Trust (simulated) — illustrative data for the demonstration only.',
    demoExplorerTimelineTitle: 'Timeline (demo)',
    demoExplorerTimelineSubtitle: 'Timeline (simulated)',
    demoExplorerNoData: 'No records (demo)',
    demoExplorerLast7Days: 'Last 7 days (demo)',
    demoExplorerPageLine: 'Page 1 of 1 · demo'
  },
  pt: {
    // mobile
    regularize: 'Regularizar agora',
    Devices: "Dispositivos",
    Subscriptions: "Plano VIP",
    Microphone: "Microfone",
    PhotoGallery: "Galeria",
    Screenshot: "Captura de Tela",
    TakeScreenshot: "Capturar Tela",
    PhotoRemote: "Foto Remota",
    support: "Suporte",
    videos: "Vídeos",
    helpAndSupport: "Ajuda e Suporte",
    Location: "Localização",
    SafeZone: "Zona Segura",
    SMS: "SMS",
    Websites: "Sites",
    keys: "Teclas",
    Keys: "Teclas",
    Contacts: "Contatos",
    WebSearch: "Pesquisas",
    whatsappChat: "WhatsApp Chat",
    whatsappAudio: "WhatsApp Áudio",
    whatsappCall: "WhatsApp Chamadas",
    telegram: "Telegram",
    tinder: "Tinder",
    kwai: "Kwai",
    badoo: "Badoo",
    snapchat: "Snapchat",
    Cell: "Celular",
    VIPService: "Atendimento VIP:",
    AddDevice: "Adicionar Dispositivo",
    TextMessageAddDevice: "Sua conta não tem nenhum dispositivo cadastrado, adicione um agora mesmo para começar o monitoramento",
    Warning: "ATENÇÃO",
    ReleaseLicense: "Você possui licença liberada em sua conta, para desbloquear todo o conteúdo do celular",
    TextUnlock: "basta clicar em desbloquear",
    UnlockContent: "Desbloquear Conteúdo",
    ContinuToTest: "Continuar no Teste",
    DeleteDevice: "Excluir Dispositivo",
    AllPlans: "Todos os Planos",
    LastUpdate: "Última Atualização:",
    Android: "Android",
    VersionWspy: "Versão App",
    LicenseValidity: "Validade da Licença",
    TestValidity: "Validade do Teste",
    ViewData: "Visualizar Dados",
    ChoosePlan: "Escolher Plano",
    TrialExpired: "Seu teste expirou, para obter acesso completo ao conteúdo escolha um plano.",
    IncreaseValidity: "Aumentar Validade",
    Computer: "Computador",
    License: "Licença",
    ShelfLife: "Validade",
    Available: "Disponível",
    OneMonth: "1 Mês",
    Months: "Meses",
    Days: "Dias",
    Day: "Dia",
    DownloadNow: "Baixar Agora",
    TxtDelete: "Ao clicar em cada botão os dados serão excluídos",
    TxtDeleteTwo: "sem confirmação",
    TxtDeleteThree: "Uma tarefa será agendada para exclusão dos dados que poderá levar até 24 horas para ser concluída.",
    TxtDownload: "Selecione os dados que deseja baixar e clique em confirmar.",
    TxtDownloadTwo: "sem confirmação",
    TxtDownloadThree: "Uma tarefa será agendada para preparar o arquivo, o que poderá levar até 24 horas. Você receberá um e-mail quando estiver pronto.",
    Return: "Voltar",
    Chats: "Chats",
    Audios: "Áudios",
    Calls: "Chamadas",
    Instagram: "Instagram",
    Battery: "Bateria",
    Connection: "Conexão",
    UpdateApp: "Versão App",
    UpdatedVersion: "Versão App",
    DataOf: "Dados do",
    Active: "Ativa",
    Inactive: "Inativa",
    WifiNetwork: "Rede WIFI",
    WifiName: "Nome da Rede WIFI",
    Number: "Número",
    Provider: "Operadora",
    ValidUntil:"Válida até:",
    TxtPayment: "Pagamento no cartão de crédito, boleto e PIX",
    Extend: "Estender",
    Purchase: "Comprar",
    TxtUnlockOne: "Leia Todo Texto Abaixo com Atenção",
    TxtUnlockTwo: "Escolha a licença que deseja aplicar ao dispositivo",
    TxtUnlockThree: "e clique em Confirmar.",
    TxtUnlockFour: "Caso o dispositivo não possua nenhuma licença, o conteúdo será desbloqueado até o vencimento da licença.",
    TxtUnlockFive: "Caso o dispositivo já esteja desbloqueado, os meses comprados serão acrescentados ao período atual do dispositivo.",
    TextUnlockSix: "ATENÇÃO: Essa ação é irreversível. Uma vez confirmado qual licença usar, não será possível ativar a mesma licença em outro dispositivo.",
    TxtUnlockSeven: "Lista de Licenças Disponíveis",
    Select: "Selecione",
    AcquiredIn: "Adquirida Em",
    ConfirmTerms: "Confirmo ter lido os termos.",
    Cancel: "Cancelar",
    MonitorAndroid: "Monitorar Celular Android",
    MonitorAndroidTwo: "Se estiver vendo esta página a partir do dispositivo que pretende monitorar, basta pressionar",
    MonitorAndroidThree: "ou, se você vai monitorar um dispositivo diferente, anote o link curto",
    ContactUs: "Fale Conosco",
    Guide: "Manual",
    ClickHere: "Clique aqui",
    MonitorComputer: "Monitorar Computador Windows",
    RegisterLicense: "ou, se já instalou no computador, basta cadastrar a licença",
    ComputerNickname: "Apelido do Computador",
    RegisterLicenseComputer: "Cadastrar Licença",
    ReleaseContent: "Liberar o Conteúdo",
    TxtReleaseContentOne: "Compre um dos planos abaixo e tenha acesso à todo conteúdo monitorado de forma completa sem restrições.",
    TxtReleaseContentTwo: "Seu conteúdo foi bloqueado por que sua conta está em teste. Compre um de nossos planos que tudo é liberado",
    JustinTime: "NA HORA",
    TxtPaymentTwo: "se pagar via Cartão de Crédito ou Pix.",
    Discount: "Desconto:",
    RecurringSubscription: "Assinatura Recorrente:",
    In: "de",
    Per: "por",
    Initial: "Inicial",
    Monthly: "Mensal",
    BuyNow: "Comprar Agora",
    SubscribeNow: "Assinar Agora",
    Telephone: "Telefone",
    Terms: "Termos",
    Today: "Hoje",
    Yesterday: "Ontem",
    LastSevenDays: "Últimos 7 dias",
    LastThirtyDays: "Últimos 30 dias",
    LastNinetyDays: "Últimos 90 dias",
    AllRecords: "Todos os Registros",
    NAME: "NOME",
    ID: "ID",
    DateTimeInstallation: "DATA/HORA INSTALAÇÃO",
    ImportantWarning: "Aviso Importante",
    Lock: "O restante do conteúdo foi bloqueado por sua conta estar na",
    FreeVersion: "Versão Gratuita",
    FreeVersionTwo: "desbloqueie o conteúdo agora mesmo.",
    ReleaseFullContent: "Liberar Conteúdo Completo",
    DateTime: "DATA/HORA",
    NumberN: "NÚMERO",
    DURATION: "DURAÇÃO",
    TYPE: "TIPO",
    Effect: "Efetuada",
    Lost: "Perdida",
    Refused: "Recusada",
    TELEPHONE: "TELEFONE",
    EMAIL: "EMAIL",
    NoData: "Nenhum contato encontrado com esse nome ou número",
    TxtVip: "Essa função está disponível apenas para dispositivos com plano VIP.",
    TxtClientVip: "Essa função está disponível apenas para clientes VIP",
    SeePlans: "Ver Planos Vip",
    DATE: "DATA",
    RESEARCHTERM: "TERMO PESQUISADO",
    LINK: "LINK",
    SearchbyTerm: "Pesquisar por termo",
    Front: "Frontal",
    Rear: "Traseira",
    TxtFrontalCamera: "* As fotos tiradas não ficam armazenadas no dispositivo monitorado.",
    TxtFrontalCamera2: "* Aguarde o recebimento de uma foto ou microfone, para acionar o comando novamente",
    TxtFrontalCamera3: "* Aparelhos que estão na versão 12 do Android, podem ser notificados quando ocorre a utilização de comandos remotos, como Foto e Microfone",
    TxtFrontalCamera4: "Nenhum item encontrado no período selecionado",
    TxtKeys: "TEXTO DIGITADO",
    APPLICATION: "APLICATIVO",
    WEBSITEACCESSED: "SITE ACESSADO",
    DELETE_NOTICE_PART_1: "Este dispositivo será excluído em",
    DELETE_NOTICE_PART_2: "dias. Escolha um plano para cancelar a exclusão.",

    // desktop
    keylogger: "Teclas Digitadas",
    sessaoDesktop: "Sessão Desktop",
    screenshots: "Telas Capturadas",
    Dashboard: "Dashboard",
    eCommerce: "comércio eletrônico",
    RedesSociais: "Redes Sociais",
    apps: "Aplicativos",
    Chamadas: "Chamadas",
    Todo: "Façam",
    WhatsChat: "WhatsApp Chats",
    WhatsAudio: "WhatsApp Audio",
    Email: "O email",
    Calendar: "Calendário",
    FullCalendar: "Calendário Completo",
    SimpleCalendar: "Calendário Simples",
    Shop: "fazer compras",
    Cart: "Carrinho",
    WishList: "Lista de Desejos",
    Checkout: "Confira",
    Monitoramento: "Monitoramento",
    DataList: "Lista de dados",
    ListView: "Exibição de lista",
    ThumbView: "Thumb View",
    Grid: "Grade",
    Vuesax: "Vuesax",
    Tailwind: "Tailwind",
    Colors: "Cores",
    Card: "Cartão",
    CreditCard: "Cartão de Crédito",
    UnlockInstantly: "Liberação Imediata",
    Basic: "Basic",
    Statistics: "Estatisticas",
    Analytics: "Analytics",
    CardActions: "Ações do Cartão",
    CardColors: "Cores do cartão",
    Table: "Mesa",
    agGridTable: "Tabela AgGrid",
    Components: "Componentes",
    Alert: "Alerta",
    Avatar: "Avatar",
    Badge: "Crachá",
    Breadcrumb: "Breadcrumb",
    Button: "Botão",
    ButtonGroup: "Grupo de botões",
    Chip: "Lasca",
    Collapse: "Colapso",
    Dialogs: "Diálogos",
    Divider: "Divisor",
    DropDown: "Suspenso",
    List: "Lista",
    Loading: "Carregando",
    Navbar: "Navbar",
    Notifications: "Notificações",
    Pagination: "Paginação",
    Popup: "Aparecer",
    Progress: "Progresso",
    Sidebar: "Barra Lateral",
    Slider: "Controle Deslizante",
    Tabs: "Guias",
    Tooltip: "dica de ferramenta",
    Upload: "Envio",
    FormsAndTable: "Formulários e tabela",
    FormElements: "Elementos do formulário",
    Switch: "Interruptor",
    Checkbox: "Caixa de seleção",
    Radio: "Rádio",
    Input: "Entrada",
    NumberInput: "Entrada numérica",
    Textarea: "Textarea",
    FormLayouts: "Layouts de formulário",
    FormWizard: "Assistente de Formulário",
    FormValidation: "Validação de Formulário",
    FormInputGroup: "Grupo de entrada de formulário",
    Pages: "PÁGINAS",
    Authentication: "Autenticação",
    Login: "Entrar",
    Register: "Registo",
    ForgotPassword: "Esqueceu A Senha",
    ResetPassword: "Redefinir Senha",
    LockScreen: "Tela de bloqueio",
    Miscellaneous: "Diversos",
    ComingSoon: "Em breve",
    Error: "Erro",
    404: "404",
    500: "500",
    NotAuthorized: "Não autorizado",
    Maintenance: "Manutenção",
    Profile: "Perfil",
    Invoice: "Fatura",
    FAQ: "Perguntas Frequentes",
    Search: "Procurar",
    KnowledgeBase: "Base de Conhecimento",
    ChartsAndMaps: "Gráficos E Mapas",
    Charts: "Gráficos",
    ApexCharts: "Apex Charts",
    chartjs: "chartjs",
    echarts: "echarts",
    chartist: "chartist",
    GoogleMap: "Google Mapa",
    Extensions: "Extensão",
    QuillEditor: "Quill-Editor",
    DragAndDrop: "Arraste e solte",
    Datepicker: "Datepicker",
    DatetimePicker: "Seletor de data e hora",
    AccessControl: "Controle de acesso",
    EditorView: "Editor View",
    AdminView: "Vista de administração",
    I18n: "I18n",
    Carousel: "Carrossel",
    Clipboard: "Prancheta",
    ContextMenu: "Menu contextual",
    StarRatings: "Classificações por estrelas",
    Autocomplete: "autocompletar",
    Tree: "Árvore",
    Others: "Outras",
    MenuLevels: "Níveis de Menu",
    MenuLevel2p1: "Nível de menu 2.1",
    MenuLevel2p2: "Nível de menu 2.2",
    MenuLevel3p1: "Nível de menu 3.1",
    MenuLevel3p2: "Nível de menu 3.2",
    DisabledMenu: "Menu desativado",
    SupportHeader: "Apoio, Suporte",
    Documentation: "Documentação",
    RaiseSupport: "Levantar Suporte",
    demoTitle: "Título do cartão",
    demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
    OneTimeFee: 'Adesão',
    PlanWillBeAppliedTo: 'O plano será aplicado no dispositivo',
    Continue: 'Continuar',
    GoBack: 'Voltar',
    demoDashboardAlert:
      'Esta tela é o painel mobile real com dados fictícios (sem chamadas à API).',
    demoNotifyTitle: 'Demonstração',
    demoNotifyText: 'A alternância de versão do painel não está disponível na demo.',
    demoExplorerBannerTitle: 'Demonstração',
    demoExplorerBannerLead:
      'Mesma estrutura visual do painel; conteúdo fictício.',
    demoExplorerCreateAccount: 'Criar Conta',
    demoExplorerSearchPlaceholder: 'Pesquisar (demo)',
    demoExplorerDemoPrefix: 'Demonstração',
    demoExplorerSocialProofTitle:
      'Confiança (simulado) — dados meramente ilustrativos para a demonstração.',
    demoExplorerTimelineTitle: 'Linha do tempo (demo)',
    demoExplorerTimelineSubtitle: 'Linha do tempo (simulada)',
    demoExplorerNoData: 'Sem registros (demo)',
    demoExplorerLast7Days: 'Últimos 7 dias (demo)',
    demoExplorerPageLine: 'Página 1 de 1 · demonstração'
  }
};
